import { render, staticRenderFns } from "./kegg.vue?vue&type=template&id=a0af829c&"
import script from "./kegg.vue?vue&type=script&lang=js&"
export * from "./kegg.vue?vue&type=script&lang=js&"
import style0 from "./kegg.vue?vue&type=style&index=0&id=a0af829c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports